import { render, staticRenderFns } from "./IcoTeamDevelopmentPlan.vue?vue&type=template&id=45dbd12e"
import script from "./IcoTeamDevelopmentPlan.vue?vue&type=script&lang=js"
export * from "./IcoTeamDevelopmentPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports